import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getProduct } from '../utils/api';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';

const ProductDetailPage = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [quantity, setQuantity] = useState(1);
  const { addItem } = useCart();
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const { data } = await getProduct(id);
        setProduct(data);
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };
    fetchProduct();
  }, [id]);

  const handleAddToCart = async () => {
    if (!user) return navigate('/login');
    await addItem(product._id, quantity);
    alert('Added to cart!');
  };

  if (loading) return <div style={{ background: '#111', minHeight: '100vh', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Loading...</div>;
  if (!product) return <div style={{ background: '#111', minHeight: '100vh', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Product not found</div>;

  return (
    <div style={{ background: '#111', minHeight: '100vh' }}>
      <Navbar />
      <div style={styles.container}>
        <div style={styles.grid}>
          <div style={styles.imageBox}>
            {product.images && product.images[0] ? (
              <img
                src={product.images[0]}
                alt={product.name}
                style={{ width: '100%', height: '100%', objectFit: 'contain', padding: '20px' }}
              />
            ) : (
              <p style={{ color: '#aaa' }}>No Image Available</p>
            )}
          </div>
          <div style={styles.details}>
            <p style={styles.brand}>{product.brand}</p>
            <h1 style={styles.name}>{product.name}</h1>
            <p style={styles.size}>Size: {product.size}</p>
            <p style={styles.category}>Category: {product.category}</p>
            {product.description && <p style={styles.description}>{product.description}</p>}
            <div style={styles.priceRow}>
              {product.isOnSale ? (
                <>
                  <span style={styles.discountedPrice}>$ {product.discountedPrice?.toLocaleString()}</span>
                  <span style={styles.originalPrice}> $ {product.price?.toLocaleString()}</span>
                  <span style={styles.badge}>{product.discountPercent}% OFF</span>
                </>
              ) : (
                <span style={styles.discountedPrice}>$ {product.price?.toLocaleString()}</span>
              )}
            </div>
            <p style={styles.stock}>Stock: {product.stock > 0 ? `${product.stock} available` : 'Out of Stock'}</p>
            <div style={styles.quantityRow}>
              <button style={styles.qtyBtn} onClick={() => setQuantity(q => Math.max(1, q - 1))}>-</button>
              <span style={styles.qty}>{quantity}</span>
              <button style={styles.qtyBtn} onClick={() => setQuantity(q => Math.min(product.stock, q + 1))}>+</button>
            </div>
            <button style={styles.cartBtn} onClick={handleAddToCart} disabled={product.stock === 0}>
              {product.stock === 0 ? 'Out of Stock' : 'Add to Cart'}
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

const styles = {
  container: { maxWidth: '1100px', margin: '0 auto', padding: '60px 20px' },
  grid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '60px' },
  imageBox: { background: '#1a1a1a', borderRadius: '12px', height: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #222' },
  details: { color: '#fff' },
  brand: { color: '#e63946', fontWeight: 'bold', textTransform: 'uppercase', marginBottom: '8px' },
  name: { fontSize: '32px', marginBottom: '12px' },
  size: { color: '#aaa', marginBottom: '8px' },
  category: { color: '#aaa', marginBottom: '16px' },
  description: { color: '#ccc', marginBottom: '24px', lineHeight: '1.6' },
  priceRow: { display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' },
  discountedPrice: { fontSize: '28px', fontWeight: 'bold', color: '#fff' },
  originalPrice: { fontSize: '16px', color: '#666', textDecoration: 'line-through' },
  badge: { background: '#e63946', color: '#fff', padding: '4px 10px', borderRadius: '4px', fontSize: '13px' },
  stock: { color: '#4caf50', marginBottom: '24px' },
  quantityRow: { display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' },
  qtyBtn: { background: '#222', color: '#fff', border: '1px solid #333', width: '36px', height: '36px', borderRadius: '6px', cursor: 'pointer', fontSize: '18px' },
  qty: { fontSize: '18px', color: '#fff', minWidth: '30px', textAlign: 'center' },
  cartBtn: { padding: '14px 32px', background: '#e63946', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '16px', cursor: 'pointer', width: '100%' }
};

export default ProductDetailPage;